/**
 * Money on this portal is whole CENTS from runner-api, never a float and never
 * computed here. This is display only.
 */
export function formatCents(cents: number, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(cents / 100);
}

/** A deduction reads as a deduction: "−$12.00", never "$-12.00" or "-$12.00". */
export function formatDeduction(cents: number, locale: string): string {
  return cents === 0 ? formatCents(0, locale) : `−${formatCents(Math.abs(cents), locale)}`;
}

/** Signed adjustments: "+$5.00" / "−$5.00" / "$0.00". */
export function formatSigned(cents: number, locale: string): string {
  if (cents === 0) return formatCents(0, locale);
  return `${cents > 0 ? '+' : '−'}${formatCents(Math.abs(cents), locale)}`;
}
